<agpr-take-over-panel
    [id]="id"
    [header]="'VisibilityIntelligence.querySetup.manuallyAddQuestionPanel.header'"
    [ariaLabel]="'VisibilityIntelligence.querySetup.manuallyAddQuestionPanel.header'"
    [overlayContainer]="overlayContainer"
    [animationTrigger]="animationTrigger"
    [hideSlideOverlay]="hideSlideOverlay"
    [responsiveWidth]="true"
    [maxPanelWidth]="560"
    [minPanelWidth]="560"
    (visibleChange)="close($event)"
>
    <div class="agpr-viManuallyAddQuestionPanel">
        <agpr-scroll-panel>
            <div class="agpr-viManuallyAddQuestionPanel-content">
                <agpr-vi-question-details
                    [id]="id + '_questionDetails'"
                    [(ngModel)]="question"
                    [showErrors]="false"
                    (ngModelChange)="updateHasError()"
                ></agpr-vi-question-details>
            </div>
        </agpr-scroll-panel>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            label="Core.button.cancel"
            [id]="id + '_cancelButton'"
            [style]="buttonTypes.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <div class="agpr-viManuallyAddQuestionPanel-footerRight">
            <div class="agpr-viManuallyAddQuestionPanel-addAnotherQuestion">
                <agpr-checkbox
                    [id]="id + '_addAnotherQuestion'"
                    [binary]="true"
                    [label]="'VisibilityIntelligence.querySetup.manuallyAddQuestionPanel.addAnother'"
                    [(ngModel)]="addAnotherQuestion"
                ></agpr-checkbox>
            </div>
            <agpr-button
                [label]="'VisibilityIntelligence.querySetup.manuallyAddQuestionPanel.actions.add'"
                [id]="id + '_addButton'"
                [style]="buttonTypes.primary"
                (click)="addQuestion()"
                [disabled]="hasError"
            ></agpr-button>
        </div>
    </ng-template>
</agpr-take-over-panel>
